import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.format()
  }

  format() {
    const input = this.element
    let value = input.value.replace(/,/g, '')

    if (value === '') {
      return
    }

    const parts = value.split('.')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    if (parts.length > 2) {
      parts.splice(2)
    }

    if (parts[1] && parts[1].length > 2) {
      parts[1] = parts[1].substring(0, 2)
    }

    input.value = parts.join('.')
  }

  handleInput(event) {
    const input = event.target
    const cursorPosition = input.selectionStart
    const previousValue = input.value
    const previousCommaCount = (previousValue.match(/,/g) || []).length

    this.format()

    const newCommaCount = (input.value.match(/,/g) || []).length
    const commaDifference = newCommaCount - previousCommaCount

    input.setSelectionRange(cursorPosition + commaDifference, cursorPosition + commaDifference)
  }
}
